export const isCallUserAnonymous = (id?: string) =>
  Boolean(id?.startsWith?.('anon_'))
